import script from "./GolfMapAreasAlert.vue?vue&type=script&lang=ts&setup=true"
export * from "./GolfMapAreasAlert.vue?vue&type=script&lang=ts&setup=true"

import "./GolfMapAreasAlert.vue?vue&type=style&index=0&id=1367e3bf&lang=scss&scoped=true"

import exportComponent from "/Users/lyon/Desktop/Work s2j/app-rentalcar-project/admin-v3 2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1367e3bf"]])

export default __exports__